<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Aquaculture</a></li>
          <li><a>Blind Feed Settings</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Quality Parameter</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by blind feed species name"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <!--Blind Feed settings block-->
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let blindfeed of blindFeedSettingsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ blindfeed && blindfeed.speciesType?.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span>Count: </span>
                  <span>{{blindfeed && blindfeed.count}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Initial Feed: </span>
                  <span>{{blindfeed && blindfeed.initial_feed}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>One to Seven Days: </span>
                  <span>{{blindfeed && blindfeed.one_to_seven_days_feed}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Seven to Fourteen Days: </span>
                  <span>{{blindfeed && blindfeed.seven_to_fourteen_days_feed}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Fourteen to Thirty Days: </span>
                  <span>{{blindfeed && blindfeed.fourteen_to_thirty_days_feed}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ blindfeed?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Business Type" (click)="getBlindFeedSetingsById(blindfeed.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Blind feed settings Not Found</div>
        <!--Blind Fedd settings block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Blind Feed Settings</div>
                <button class="add-update-submit-button" (click)="addUpdateBlindFeedSettings()" [disabled]="blindFeedDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Species Type Category</mat-label>
                  <mat-select id="sitename" formControlName="species_type_id">
                    <mat-option value="" disabled>Select Species Type</mat-option>
                    <mat-option *ngFor="let category of speciesTypes" [value]="category.id"> {{ category.name }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="blindFeedSettingsFormValidation.species_type_id.invalid"><i>Select species type</i></mat-hint>
                  <mat-hint *ngIf="blindFeedSettingsFormValidation.species_type_id.valid"><i>Species type selected</i></mat-hint>
                  <mat-error *ngIf="(blindFeedSettingsFormValidation.species_type_id.touched || blindFeedSettingsFormValidation.species_type_id.dirty || submitted) && blindFeedSettingsFormValidation.species_type_id.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Count</mat-label>
                  <input matInput id="unitCode" type="text" autocomplete="off" formControlName="count" placeholder="Enter count"/>
                  <mat-hint><i>3–300 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(blindFeedSettingsFormValidation.count.touched || blindFeedSettingsFormValidation.count.dirty || submitted) && blindFeedSettingsFormValidation.count.errors">
                    <i> {{blindFeedSettingsFormValidation.count.hasError('required') ? 'Required.' : blindFeedSettingsFormValidation.count.hasError('minlength') ? 'Minimum 3 characters required.' : blindFeedSettingsFormValidation.count.hasError('maxlength') ? 'Maximum 300 characters allowed.' : blindFeedSettingsFormValidation.count.hasError('pattern') ? 'Only number allowed.' : ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Initial Feed</mat-label>
                  <input matInput id="initial" type="text" autocomplete="off" formControlName="initial_feed" placeholder="Initial Feed"/>
                  <mat-hint><i>1–300 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(blindFeedSettingsFormValidation.initial_feed.touched || blindFeedSettingsFormValidation.initial_feed.dirty || submitted) && blindFeedSettingsFormValidation.initial_feed.errors">
                    <i> {{blindFeedSettingsFormValidation.initial_feed.hasError('required') ? 'Required.' : blindFeedSettingsFormValidation.initial_feed.hasError('minlength') ? 'Minimum 3 characters required.' : blindFeedSettingsFormValidation.initial_feed.hasError('maxlength') ? 'Maximum 300 characters allowed.' : blindFeedSettingsFormValidation.initial_feed.hasError('pattern') ? 'Only number allowed.' : ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>One To Seven Days Feed</mat-label>
                  <input matInput id="seven" type="text" autocomplete="off" formControlName="one_to_seven_days_feed" placeholder="One To Seven Days Feed"/>
                  <mat-hint><i>1–300 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(blindFeedSettingsFormValidation.one_to_seven_days_feed.touched || blindFeedSettingsFormValidation.one_to_seven_days_feed.dirty || submitted) && blindFeedSettingsFormValidation.one_to_seven_days_feed.errors">
                    <i> {{blindFeedSettingsFormValidation.one_to_seven_days_feed.hasError('required') ? 'Required.' : blindFeedSettingsFormValidation.one_to_seven_days_feed.hasError('minlength') ? 'Minimum 3 characters required.' : blindFeedSettingsFormValidation.one_to_seven_days_feed.hasError('maxlength') ? 'Maximum 300 characters allowed.' : blindFeedSettingsFormValidation.one_to_seven_days_feed.hasError('pattern') ? 'Only number allowed.' : ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Seven To Fourteen Days Feed</mat-label>
                  <input matInput id="fourteen" type="text" autocomplete="off" formControlName="seven_to_fourteen_days_feed" placeholder="Seven To Fourteen Days Feed"/>
                  <mat-hint><i>1–300 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(blindFeedSettingsFormValidation.seven_to_fourteen_days_feed.touched || blindFeedSettingsFormValidation.seven_to_fourteen_days_feed.dirty || submitted) && blindFeedSettingsFormValidation.seven_to_fourteen_days_feed.errors">
                    <i> {{blindFeedSettingsFormValidation.seven_to_fourteen_days_feed.hasError('required') ? 'Required.' : blindFeedSettingsFormValidation.seven_to_fourteen_days_feed.hasError('minlength') ? 'Minimum 3 characters required.' : blindFeedSettingsFormValidation.seven_to_fourteen_days_feed.hasError('maxlength') ? 'Maximum 300 characters allowed.' : blindFeedSettingsFormValidation.seven_to_fourteen_days_feed.hasError('pattern') ? 'Only number allowed.' : ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Fourteen To Thirty Days Feed</mat-label>
                  <input matInput id="thirty" type="text" autocomplete="off" formControlName="fourteen_to_thirty_days_feed" placeholder="Fourteen To Thirty Days Feed"/>
                  <mat-hint><i>1–300 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(blindFeedSettingsFormValidation.fourteen_to_thirty_days_feed.touched || blindFeedSettingsFormValidation.fourteen_to_thirty_days_feed.dirty || submitted) && blindFeedSettingsFormValidation.fourteen_to_thirty_days_feed.errors">
                    <i> {{blindFeedSettingsFormValidation.fourteen_to_thirty_days_feed.hasError('required') ? 'Required.' : blindFeedSettingsFormValidation.fourteen_to_thirty_days_feed.hasError('minlength') ? 'Minimum 3 characters required.' : blindFeedSettingsFormValidation.fourteen_to_thirty_days_feed.hasError('maxlength') ? 'Maximum 300 characters allowed.' : blindFeedSettingsFormValidation.fourteen_to_thirty_days_feed.hasError('pattern') ? 'Only number allowed.' : ''}}</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
